module.exports = __webpack_public_path__ + "public/img/logo.cd95c421.svg";